<template>
    <div 
      class="progress-bar"
      :style="{ '--progress': progress + '%' }"
    />

</template>

<script setup>
import { computed } from 'vue';
import { splitByCapitals } from '@/helpers/strings';

const props = defineProps({
  totalMilestones: Number,
  currentMilestone: Number,
  currentMilestoneName: String
});

const progress = computed(() => {
  return Math.round(((props.currentMilestone) / props.totalMilestones) * 100);
});

</script>

<style scoped>
.progress-bar::after {
  background-color: #FF5A50;
}

div {
  margin-top: 10px;
}

</style>
